const state = {
  show: false,
  component: ''
}

const mutations = {
  setShow (state, show) {
    state.show = show
  },

  setComponent (state, component) {
    state.component = component
  }
}

const actions = {
  show ({ commit }, component) {
    commit('setShow', true)
    commit('setComponent', component)
  },

  hide ({ commit }) {
    commit('setShow', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
